import { LogManager } from "@mcleod/core";
import { AutogenLayoutMobileCommControlList } from "./autogen/AutogenLayoutMobileCommControlList";

const log = LogManager.getLogger("lme.dispatch.mobilecomm.MobileCommControlList");

export class MobileCommControlList extends AutogenLayoutMobileCommControlList {

    async onLoad() {
        log.debug("Mobile Comm Control List initialized");
    }
}
